import React from 'react'
import PropTypes from 'prop-types'

import ContentModal from '../../common/ContentModal'

function HintSelectionModal(props) {
  const { hints, onSelectHint, onClose } = props
  return (
    <ContentModal id="instruction-panel-hint-modal" onClose={onClose}>
      <div style={{ padding: 40 }}>
        <h3>Hints</h3>
        <ul>
          {hints.map((hint, index) => (
            <li key={hint.id}>
              <a href="#" onClick={() => onSelectHint(index)}>{hint.title}</a>
            </li>
          ))}
        </ul>
      </div>
    </ContentModal>
  )
}
HintSelectionModal.propTypes = {
  hints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
  onSelectHint: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default HintSelectionModal
